module.exports = __webpack_public_path__ + "img/144-algeria.4e0683de.svg";